import { Ajax } from "../../../Common/Ajax";
import { GlobalData } from "../../../Common/GlobalData";
import { Confirm, Notification, TemplateHelpers } from "../../../Common/KendoHelpers";

export class Index {
    private readonly NUM_DAYS = '#numDays';
    private readonly UPDATE_NUM_DAYS = '#updateNumDays';
    private readonly GRID = '#grid';

    constructor() {
        this.init();
    }

    private init() {
        $(this.NUM_DAYS).kendoNumericTextBox({
            value: 25,
            format: '0',
            decimals: 0,
            min: 1
        });

        $(this.UPDATE_NUM_DAYS).on('click', () => {
            const grid = $(this.GRID).data('kendoGrid')!;
            grid.dataSource.pageSize(this.getNumDays());
        });

        $(this.GRID).kendoGrid({
            dataSource: {
                transport: {
                    read: GlobalData.URL_BASE + 
                    GlobalData.URL_SUFFIX_IBD_LEADERBOARD_MARKET_SCHOOL
                },
                pageSize: this.getNumDays(),
                serverPaging: true,
                serverSorting: true,
            },
            height: 915,
            groupable: false,
            sortable: false,
            pageable: false,
            detailInit: this.openDetail,
            columns: [{
                field: 'tradingDate',
                title: 'Trading<br>Date',
                width: '50px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('tradingDate')),
            }, {
                title: 'Day',
                width: '43px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getTradingDayTemplate('tradingDate')),
            }, {
                field: 'buySwitch',
                title: 'Buy<br>Switch',
                width: '50px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(jQuery("#BuySwitch-template").html()),
            }, {
                field: 'restraint',
                title: 'Restraint',
                width: '50px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'powerTrend',
                title: 'Power Trend',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(jQuery("#PowerTrend-template").html()),
            }, {
                field: 'floor',
                title: 'Floor',
                width: '50px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: "{0:n0}",
            }, {
                field: 'distributionCount',
                title: 'Distr.<br>Count',
                width: '50px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(jQuery("#DistributionCount-template").html()),
                format: "{0:n0}",
            }, {
                field: 'exposureCount',
                title: 'Exposure<br>Count',
                width: '50px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(jQuery("#ExposureCount-template").html()),
                format: "{0:n0}",
            }, {
                field: 'exposurePct',
                title: 'Exposure<br>Percent',
                width: '50px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(jQuery("#ExposurePct-template").html())
            }, {
                field: 'chartMarkup',
                title: 'Mark<br>Up',
                width: '30px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(jQuery("#ChartMarkup-template").html()),
            }]
        });
    }

    private getNumDays() {
        return parseInt($(this.NUM_DAYS).val()?.toString() || '');
    }

    private openDetail(e: any) {
        const urlSuffix = GlobalData.URL_SUFFIX_IBD_LEADERBOARD_MARKET_SCHOOL +
            '/Detail?tradingDate=' + e.data.tradingDate;

        const success = (data: any) => {
            if (e.detailCell != null) {
                e.detailCell.html(data);
            }
        };

        const error = () => {
            e.detailCell = null;
        }

        Ajax.invoke(urlSuffix, 'GET', null, success, error);
    }

    public delete(tradingDate: string) {
        const onDone = () => {
            const urlSuffix = GlobalData.URL_SUFFIX_IBD_LEADERBOARD_MARKET_SCHOOL +
                '?tradingDate=' + tradingDate;
            const msg = new Notification();

            const success = () => {
                msg.success('The record for ' + tradingDate + ' was deleted successfully');
                $(this.GRID).data('kendoGrid')?.dataSource.read();
            };

            const error = () => {
                msg.error('The record for ' + tradingDate + ' could not be deleted');
            }

            Ajax.invoke(urlSuffix, 'DELETE', null, success, error);
        };

        const onFail = () => {
            // Do nothing.
        };

        const confirm = new Confirm(
            'Are you sure you want to delete the record for ' + tradingDate + '?',
            onDone, onFail);
        confirm.show();
    }
}
